/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import React from 'react';
import ReactDOM from 'react-dom';
import container from 'modules/section-content';
import splash from './partners-page.pug';
import metadata from './metadata.json';
import FormApp from './components';

let unmountForm = () => {};

export default function register() {
  page('/partners', render, snippets);
  page.exit('/partners', () => {
    unmountForm();
  });
}

function renderReactComponent(instance, element) {
  let rendered = false;
  ReactDOM.render(instance, element, setRenderedTrue);

  return unMountReactComponent;

  function setRenderedTrue() {
    rendered = true;
  }

  function unMountReactComponent() {
    if (rendered) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}

function renderFormComponent() {
  return renderReactComponent(<FormApp />, document.getElementById('partners-form-app'));
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function snippets(ctx, next) {
  unmountForm = renderFormComponent();
  $('.stalker-menu-container').stalkerMenu();

  // "Go to" script
  $('a[data-go-to]').click(function() {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') ||
      location.hostname === this.hostname
    ) {
      let target = $(this.hash);
      target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
      if (target.length) {
        $('html,body').animate(
          {
            scrollTop: target.offset().top
          },
          1000
        );
        return false;
      }
    }
  });

  // Show on scroll
  const $animation_elements = $('.item .images');
  const $animation_elements_span = $('#ico > span');
  const $window = $(window);

  function check_if_in_view() {
    const window_height = $window.height();
    const window_top_position = $window.scrollTop();
    const window_bottom_position = window_top_position + window_height;

    $.each($animation_elements_span, function() {
      const $element = $(this);
      const element_height = $element.outerHeight();
      const element_top_position = $element.offset().top;
      const element_bottom_position = element_top_position + element_height;

      // check to see if this current container is within viewport
      if (
        element_bottom_position >= window_top_position &&
        element_top_position <= window_bottom_position
      ) {
        $element.addClass('animate');
      }
    });

    $.each($animation_elements, function() {
      const $element = $(this);
      const element_height = $element.outerHeight();
      const element_top_position = $element.offset().top;
      const element_bottom_position = element_top_position + element_height;

      // check to see if this current container is within viewport
      if (
        element_bottom_position >= window_top_position &&
        element_top_position <= window_bottom_position
      ) {
        $element.addClass('animate');
      }
    });
  }

  $window.on('scroll resize', check_if_in_view);
  $window.trigger('scroll');

  next();
}



// WEBPACK FOOTER //
// ./src/pages/partners/partners.js